import { combineReducers } from 'redux'

import filters from './filters'

export default combineReducers({
  filters,
})
